import React from "react";
import "./compoments.css"
import NavigationBar from "./NavigationBar";
const Header = ()=>{
    return( 
        <>
         <NavigationBar />

        <header>
            <div className ="container-fluid">
                <div className ="row">
                     <div className="col-md-12">
                    <h1 className="text-center display-1 Hero text-white">Diamonds And Rust</h1>
                    <hr className="bg-white m-3"/>
                    <h3 className="text-center display-5">Every Thursday 19:30 at <a href="https://darkwaveradio.net/" className="nav-link text-danger">Darkwave Radio</a> </h3>
                    <a href="https://www.buymeacoffee.com/RozzyM"><img src="https://img.buymeacoffee.com/button-api/?text=Buy me a beer&emoji=&slug=RozzyM&button_colour=FF5F5F&font_colour=ffffff&font_family=Cookie&outline_colour=000000&coffee_colour=FFDD00" /></a>
                </div>
                </div>
               
            </div>
        </header>
        </>

    );
};

export default  Header;
